<div class="modal-container">
  @if (isLoading) {
    <div class="loading-container">
      <mat-progress-spinner [diameter]="32" mode="indeterminate" color="accent" ></mat-progress-spinner>
      <span class="loading-text">Loading...</span>
    </div>
  } @else {
    <div class="modal-header">
      <div class="modal-header__title">
        <h2>{{ selectedReferenceTitle() }}</h2>
        @if (sourceTitle() && sourceTitle() !== selectedReferenceTitle()) {
          <p class="reference-title-caption">Source: {{ sourceTitle() }}</p>
        }
      </div>

      @if (referencesForSelector(); as selectorReferences) {
        @if (selectorReferences.length) {
        <div class="ref-selector-panel">
          <div class="ref-selector-panel__label">References</div>
          <div class="ref-selector-container">
            @for (ref of selectorReferences; track ref.listPositionIndex ?? $index) {
              <button type="button" class="ref-selector" [class.active]="currentSelectedReference?.listPositionIndex === ref.listPositionIndex" (click)="selectReference(ref)">
                <span class="ref-selector__label">Ref.</span>
                <span class="ref-selector__value">{{ ref.uiDisplayLabel || ref.listPositionIndex }}</span>
              </button>
            }
          </div>
        </div>
        }
      }

      @if (currentSelectedReference?.uiAccuracy || currentSelectedReference?.uiReasoning || currentHighlightText) {
        <div class="ref-details">
          @if (currentSelectedReference?.uiAccuracy) {
            <div class="ref-accuracy"> <strong>Accuracy:</strong> {{ currentSelectedReference?.uiAccuracy }} </div>
          }
          @if (currentSelectedReference?.uiReasoning) {
            <div class="ref-reasoning"> <strong>Reasoning:</strong> {{ currentSelectedReference?.uiReasoning }} </div>
          }
          @if (currentHighlightText) {
            <div class="ref-embeddingContent"> <strong>Referenced text:</strong> {{ currentHighlightText }} </div>
          }
        </div>
      }
    </div>

    <div class="modal-content">
      @if (selectedExternalReferences().length > 0) {
        <div class="content-card external-refs-content">
          @for (extRef of selectedExternalReferences(); track extRef.referenceText; let i = $index) {
            <div class="selected-ref-list__item" [class.selected-ref-list__item--active]="selectedExternalReferenceIndex() === i" >
              <div class="selected-ref-list__label"> Ref. {{ currentSelectedReference?.uiDisplayLabels?.[i] ?? i + 1 }} </div>
              <div class="selected-ref-list__text">{{ extRef.referenceText }}</div>
              @if (extRef.referenceLink) {
                <a [href]="extRef.referenceLink" target="_blank" rel="noopener noreferrer"> {{ extRef.referenceLink }} </a>
              }
            </div>
          }
        </div>
      }
      <div class="content-card source-container">
        <div class="content-card__header">
          <h3>Source content</h3>
        </div>
        @if (sourceNotFound) {
          <div class="source-not-found">
            <span class="source-not-found-icon">⚠</span>
            <h3>Source no longer available</h3>
            <p>This source document has been removed or is no longer accessible. The reference was valid when the response was generated.</p>
          </div>
        } @else {
          <div class="mark-text">{{ source?.content }}</div>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button (click)="cancel()" color="accent" mat-raised-button>Close</button>
      <div class="footer-actions">
        <button (click)="goToSource()" [disabled]="!source" class="m-r-16" color="accent" mat-raised-button > See details </button>
        <button (click)="goToOriginal()" [disabled]="!selectedReferenceUrl() && !goToSourceService.hasSourceLink()" color="accent" mat-raised-button > Open source destination </button>
      </div>
    </div>
  }
</div>
